<div
  class="avatar background {{ containerColor }} {{ shape }}"
  *ngIf="icon && !imageUrl"
  [style.width]="containerSize + 'px'"
  [style.height]="containerSize + 'px'"
  [style.max-width]="maxContainerSize + 'px'"
  [style.max-height]="maxContainerSize + 'px'"
>
  <mat-icon
    [color]="iconColor"
    [style.width]="iconSize + 'px'"
    [style.height]="iconSize + 'px'"
    [style.max-width]="maxIconSize + 'px'"
    [style.max-height]="maxIconSize + 'px'"
    [style.font-size]="iconSize + 'px'"
    >{{ icon }}</mat-icon
  >
</div>

<img
  *ngIf="imageUrl"
  [src]="imageUrl"
  alt=""
  class="avatar {{ shape }}"
  [style.width]="containerSize + 'px'"
  [style.height]="containerSize + 'px'"
/>
